import Box from "@mui/joy/Box";
import LanguageIcon from "@mui/icons-material/Language";
import StorageIcon from "@mui/icons-material/Storage";
import SpeedIcon from "@mui/icons-material/Speed";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Card, CardContent, Grid } from "@mui/material";
import HightChartLine from "./HightChart";
import { GetInfoResult } from "upcx-js/dist/upcxjs-rpc-interfaces";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";

interface Props {
  chainInfo?: GetInfoResult;
  txCount?: number;
}

const RatePanel = ({ chainInfo, txCount }: Props) => {
  const { quoteUSD } = useUpcxChain();

  const [themeLight] = useRecoilState(ThemeLight);

  return (
    <>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn="span 3">
          <Card
            sx={{ minWidth: 275 }}
            className="card py-5  mb-4 mt-n12"
            variant="outlined"
          >
            <CardContent className="py-0">
              <div className="d-flex">
                <div className="me-3">
                  <img
                    className="img-fluid mx-auto"
                    width="30"
                    src={
                      themeLight
                        ? "/assets/img/coin_logo.svg"
                        : "/assets/img/coin_logo_white.png"
                    }
                    alt="UPCX Logo"
                  />
                </div>
                <div className="flex-grow-1">
                  <div className="text-cap mb-px">UPC Price</div>
                  <a
                    className="link-dark fs-base"
                    href="/chart/upcxprice"
                    rel="tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    ${quoteUSD?.marketCapPrice.toLocaleString()}&nbsp;
                    {/* <span className="text-muted me-1">
                      {" "}
                      @ {quoteJPY?.marketCapPrice.toLocaleString()} JPY
                    </span> */}
                    <span
                      className={`text-${
                        quoteUSD?.marketCapRisePercentage &&
                        quoteUSD?.marketCapRisePercentage > 0
                          ? "success"
                          : "danger"
                      } small`}
                    >
                      {quoteUSD?.marketCapRisePercentage &&
                      quoteUSD?.marketCapRisePercentage > 0 ? (
                        <TrendingUpIcon className="text-icon text-success" />
                      ) : (
                        <TrendingDownIcon className="text-icon text-danger" />
                      )}
                      {Math.abs(quoteUSD?.marketCapRisePercentage ?? 0).toFixed(
                        2
                      )}
                      %
                    </span>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </Box>
        <Box gridColumn="span 3">
          <Card
            sx={{ minWidth: 275 }}
            className="card py-5  mb-4 mt-n12"
            variant="outlined"
          >
            <CardContent className="py-0">
              <div className="d-flex">
                <div className="me-3">
                  <LanguageIcon
                    sx={themeLight ? {} : { color: "white !important" }}
                  />
                </div>
                <div className="flex-grow-1">
                  <div className="text-cap mb-px">Market Cap</div>
                  <a className="link-dark fs-base" href="/stat/supply">
                    ${quoteUSD?.marketCapVolumn.toLocaleString()}
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </Box>
        <Box gridColumn="span 3">
          <Card
            sx={{ minWidth: 275 }}
            className="card py-5  mb-4 mt-n12"
            variant="outlined"
          >
            <CardContent className="py-0">
              <hr className="d-block d-md-none my-5" />
              <div className="d-flex">
                <div className="me-3">
                  <StorageIcon
                    sx={themeLight ? {} : { color: "white !important" }}
                  />
                </div>
                <div className="flex-grow-1">
                  <div className="text-cap mb-px">Transactions</div>
                  <a
                    href="/txs"
                    className="link-dark fs-base"
                    rel="tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    data-bs-html="true"
                  >
                    {txCount?.toLocaleString()}
                  </a>
                  <span
                    className="text-muted small"
                    rel="tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    {" "}
                    (0 TPS)
                  </span>
                </div>
                <div className="text-end">
                  <div className="text-cap mb-px">Gas Price</div>
                  0.00001 UPC <span className="text-muted small">(≈$0)</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </Box>
        <Box gridColumn="span 3">
          <Card
            sx={{ minWidth: 275 }}
            className="card py-5  mb-4 mt-n12"
            variant="outlined"
          >
            <CardContent className="py-0">
              <div className="d-flex">
                <div className="me-3">
                  <SpeedIcon
                    sx={themeLight ? {} : { color: "white !important" }}
                  />
                </div>
                <div className="flex-grow-1">
                  <div className="text-cap mb-px">Last Finalized Block</div>
                  <span
                    rel="tooltip"
                    className="fs-base"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    {chainInfo?.head_block_num}
                  </span>
                </div>
                <div className="text-end">
                  <div className="text-cap mb-px">Last Safe Block</div>
                  <span
                    rel="tooltip"
                    className="fs-base"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    {chainInfo?.head_block_num}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        </Box>
      </Box>

      <Grid container height={200} className="card mb-4">
        <Grid item lg={12} className="p-4">
          <Box className="text-cap mb-px">Transaction History in one month</Box>
        </Grid>

        <Grid item lg={12} height={200}>
          <HightChartLine></HightChartLine>
        </Grid>
      </Grid>
    </>
  );
};

export default RatePanel;
